import React, { useState, useEffect, useCallback, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { Button, Modal, Form, Row, Col, InputGroup, Tabs, Tab, Spinner } from "react-bootstrap";
import { CopyToClipboard } from "react-copy-to-clipboard";
import SearchIcon from "@material-ui/icons/Search";
import PlacesAutoComplete from "../../../components/AddressAutoComplete";
import * as Admin from "../../../store/ducks/admin.duck";
import * as Reference from "../../../store/ducks/reference.duck";
import * as Auth from "../../../store/ducks/auth.duck";
import { Grid, Paper, TextField, makeStyles } from "@material-ui/core";
import DescriptionIcon from "@material-ui/icons/Description";
import { ToastContainer, Flip } from "react-toastify";
import Alert from "@material-ui/lab/Alert";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { saveAs } from "file-saver";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import IconButton from "@material-ui/core/IconButton";
import "react-toastify/dist/ReactToastify.css";

const useStyles = makeStyles((theme) => ({
  noBorder: {
    border: "none",
  },
  formControl: {
    margin: 0, //theme.spacing(1),
    minWidth: 120,
  },
  formControlWide: {
    margin: 0, //theme.spacing(1),
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  label: {
    backgroundColor: "#fff",
    paddingLeft: 3,
    paddingRight: 3,
  },
}));

export default function CsCentres() {
  const [searchTerm, setSearchTerm] = useState("");
  const csCentres = useSelector((state) => state.admin.CsCentresAdmin);
  const [key, setKey] = React.useState("centreDetails");
  const role = useSelector((state) => state.auth.roleDesc);
  const [showCsAgent, setShowCsAgent] = useState(false);
  const [csAgentError, setCsAgentError] = useState("");
  const [expandedRowId, setExpandedRowId] = useState(null);
  const userAdmin = useSelector((state) => state.auth.userAdmin);

  const searchCsCentres = (csCentre) => {
    const term = searchTerm.toLowerCase();
    if (!term) return true;
    return (
      csCentre.centerName?.toLowerCase().includes(term) ||
      csCentre.flagClean?.toLowerCase().includes(term) ||
      csCentre.contactPhone?.toLowerCase().includes(term) ||
      csCentre.contactEmail?.toLowerCase().includes(term) ||
      // Search inside the CSAgents list
      csCentre.csAgents?.some((agent) => agent.toLowerCase().includes(term))
    );
  };

  const filteredCsCentres = csCentres.filter((csCentre) => searchCsCentres(csCentre));
  const dispatch = useDispatch();
  const classes = useStyles();
  useEffect(() => {
    dispatch(Reference.actions.fetchTimeZone());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Admin.actions.fetchCsCentresAdmin());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Reference.actions.fetchUsers());
  }, [dispatch]);
  const users = useSelector((state) => state.reference.Users);
  const actualUsers = users.filter((user) => user.status === "Active" && user.rolescope === "");
  const userTZ = useSelector((state) => state.auth.userTZ);
  const timeZone = useSelector((state) => state.reference.TimeZone);
  const csAgents = useSelector((state) => state.admin.CsAgents);
  const csContactDownload = useSelector((state) => state.admin.CsContactDownload);

  var [show, setShow] = useState(false);
  var [currentID, setCurrentID] = useState();
  var [currentCenterName, setCurrentCenterName] = useState();
  var [currentEmail, setCurrentEmail] = useState();
  var [currentPhone, setCurrentPhone] = useState();
  var [currentFax, setCurrentFax] = useState();
  var [currentContact, setCurrentContact] = useState();
  var [currentContactEmail, setCurrentContactEmail] = useState();
  var [currentContactPhone, setCurrentContactPhone] = useState();
  var [currentFullAddress, setCurrentFullAddress] = useState();
  var [currentPostCode, setCurrentPostCode] = useState();
  var [currentLongitude, setCurrentLongitude] = useState();
  var [currentLatitude, setCurrentLatitude] = useState();
  var [currentWebsite, setCurrentWebsite] = useState();
  var [currentPracticeType, setCurrentPracticeType] = useState();
  var [currentmmmCode, setCurrentmmmCode] = useState();
  var [currentEligibility1, setCurrentEligibility1] = useState();
  var [currentEligibility2, setCurrentEligibility2] = useState();
  var [currentEligibility3, setCurrentEligibility3] = useState();
  var [currentEligibilitySpecial, setCurrentEligibilitySpecial] = useState();
  var [currentPathWaysLink, setCurrentDocumentLink] = useState();
  var [currentNewPathwaysDocument, setCurrentNewPathwaysDocument] = useState();
  var [currentDefaultReminderEmail, setCurrentDefaultReminderEmail] = useState("");
  var [currentAgentID, setcurrentAgentID] = useState();
  var [currentAgentFirstName, setcurrentAgentFirstName] = useState();
  var [currentAgentSurname, setcurrentAgentSurname] = useState();
  var [currentAgentEmail, setcurrentAgentEmail] = useState();
  var [currentAgentMobile, setcurrentAgentMobile] = useState();
  var [currentAgentNewPasswordConfirmation, setcurrentAgentNewPasswordConfirmation] = useState();
  var [currentAgentNewPassword, setcurrentAgentNewPassword] = useState();
  var [currentAgentStatus, setcurrentAgentStatus] = useState();
  var [currentAgentModalHeader, setcurrentAgentModalHeader] = useState();
  var [currentAgentPasswordHeader, setcurrentAgentPasswordHeader] = useState();
  var [currentAgentTimeZone, setcurrentAgentTimeZone] = useState(userTZ ? userTZ : "AUS Eastern Standard Time");
  var [currentAgentAdmin, setcurrentAgentAdmin] = useState("No");
  var [currentRHCContact, setCurrentRHCContact] = useState(0);
  var [currentOpenHours, setCurrentOpenHours] = useState("");
  var [currentRating, setCurrentRating] = useState(1);
  var [currentEngagementStrategy, setCurrentEngagementStrategy] = useState("");
  var [currentNotes, setCurrentNotes] = useState("");
  var [currentCentreID, setCurrentCentreID] = useState();
  var [currentAgentMFAStatus, setcurrentAgentMFAStatus] = useState(null);

  // Contact Download
  var [contactDownloadName, setcontactDownloadName] = useState("");
  var [contactDownloadType, setcontactDownloadType] = useState("CentreContact");
  var [contactDownloadStatus, setcontactDownloadStatus] = useState("Not Started");
  var [activeDownloadType, setActiveDownloadType] = useState(null);

  function DeactivateMFA(id) {
    // Update local state
    setcurrentAgentMFAStatus(null);
    // Ok Time to Dispatch
    dispatch(Auth.actions.putDeactivateMFAAdmin({ type: "CS", id: id }));
  }

  // initial call from the download button - fires fetch action if needed, otherwise triggers download
  const exportFile = (type) => {
    if (contactDownloadStatus !== "Not Started") return;
    dispatch(Admin.actions.fetchCSContactDownload({ contactType: type }));
    setcontactDownloadStatus("Fetching");
  };

  // grab the blob from state and tell the browser to download
  const downloadExport = useCallback(() => {
    //
    if (csContactDownload && csContactDownload !== "") {
      const file = new Blob([csContactDownload], {
        type: "text/csv;charset=utf-8",
      });
      saveAs(file, `${contactDownloadName}.csv`);
    }
  }, [csContactDownload, contactDownloadName]);

  // useEffect to fire when status is 'Fetching' and we get the result in redux
  useEffect(() => {
    if (contactDownloadStatus === "Fetching" && csContactDownload && csContactDownload !== "") {
      downloadExport();
      setcontactDownloadStatus("Not Started");
      setActiveDownloadType(null);
    }
  }, [contactDownloadStatus, csContactDownload, downloadExport]);

  const startDownload = (type, name) => {
    if (contactDownloadStatus !== "Not Started") return;

    setActiveDownloadType(type);
    setcontactDownloadType(type);
    setcontactDownloadName(name);
    exportFile(type);
  };

  function handleCsAgentClose() {
    setShowCsAgent(false);
  }

  function loadNewCsAgent() {
    setcurrentAgentModalHeader("Adding CS Staff");
    setcurrentAgentPasswordHeader("Please enter password for new login");
    setcurrentAgentID(0);
    setcurrentAgentFirstName("");
    setcurrentAgentSurname("");
    setcurrentAgentEmail("");
    setcurrentAgentMobile("");
    setcurrentAgentAdmin("No");
    setcurrentAgentStatus("Active");
    setCsAgentError("");
    setShowCsAgent(true);
    setcurrentAgentNewPassword(null);
    setcurrentAgentNewPasswordConfirmation(null);
    setcurrentAgentTimeZone("AUS Eastern Standard Time");
    setcurrentAgentMFAStatus(null);
  }

  function handleTimeZoneAutocompleteChange(propertyName, event, newValue) {
    if (newValue) {
      setcurrentAgentTimeZone(newValue.systemName);
    }
  }

  const loadExistingCsAgent = (thisCsAgent) => {
    setcurrentAgentModalHeader("Updating " + thisCsAgent.firstname + " " + thisCsAgent.surname);
    setcurrentAgentPasswordHeader("Password Update (Leave blank unless resetting)");
    setcurrentAgentID(thisCsAgent.id);
    setcurrentAgentFirstName(thisCsAgent.firstname);
    setcurrentAgentSurname(thisCsAgent.surname);
    setcurrentAgentEmail(thisCsAgent.email);
    setcurrentAgentMobile(thisCsAgent.mobilephone);
    setcurrentAgentStatus(thisCsAgent.status);
    setcurrentAgentTimeZone(thisCsAgent.timezone);
    setcurrentAgentAdmin(thisCsAgent.admin);
    setcurrentAgentNewPassword(null);
    setcurrentAgentNewPasswordConfirmation(null);
    setcurrentAgentMFAStatus(thisCsAgent.mfaconfigured);
    setCsAgentError("");
    setShowCsAgent(true);
  };

  function postCsAgent() {
    let validation = true;
    // Check if passwords are the same
    if (currentAgentNewPassword) {
      // Check passwords are the same
      if (currentAgentNewPassword !== currentAgentNewPasswordConfirmation) {
        setCsAgentError("Passwords do not match");
        validation = false;
      }
    }
    if (currentAgentFirstName === "" || currentAgentSurname === "" || currentAgentEmail === "" || currentAgentMobile === "") {
      setCsAgentError("You must complete all manadatory* fields.");
      validation = false;
    }
    //
    // Submit if no errors
    if (validation) {
      setCsAgentError("");
      var payload = {
        id: currentAgentID,
        firstname: currentAgentFirstName,
        surname: currentAgentSurname,
        email: currentAgentEmail,
        mobilephone: currentAgentMobile,
        csCentreID: currentID,
        admin: currentAgentAdmin,
        status: currentAgentStatus,
        timezone: currentAgentTimeZone,
        newpassword: currentAgentNewPassword,
        newpasswordconfirmation: currentAgentNewPasswordConfirmation,
      };
      dispatch(Admin.actions.putCsAgent(payload));
      setShowCsAgent(false);
    }
  }

  const agentColumns = [
    { field: "id", headerName: "ID", hide: true },
    {
      field: "fullname",
      headerName: "Name",
      width: 190,
      renderCell: (params) => {
        const isAdmin = params.row.admin === "Yes";

        return (
          <strong>
            <div
              onClick={() => loadExistingCsAgent(csAgents.find((agent) => agent.id === params.row.id))}
              className="cell-Link"
              style={{
                color: isAdmin ? "#1976d2" : "inherit",
                fontWeight: isAdmin ? 600 : 500,
              }}
            >
              {params.value}
            </div>
          </strong>
        );
      },
    },
    {
      field: "email",
      headerName: "Email",
      width: 220,
      renderCell: (params) => (
        <CopyToClipboard text={params.row.email}>
          <span className="cell-Link" style={{ fontWeight: 500 }}>
            {params.row.email}
          </span>
        </CopyToClipboard>
      ),
    },
    { field: "mobilephone", headerName: "Phone", width: 110 },
    { field: "admin", headerName: "Admin", width: 110 },
    { field: "status", headerName: "Status", width: 115 },
  ];

  const loadCsCentreDetail = (thisCsCentre) => {
    // Need to load CS Agents for this centre
    dispatch(Admin.actions.fetchCsAgents({ csCentreID: thisCsCentre.id }));
    // Load details
    setCurrentID(thisCsCentre.id);
    setCurrentCenterName(thisCsCentre.centerName);
    setCurrentEmail(thisCsCentre.email);
    setCurrentPhone(thisCsCentre.phone);
    setCurrentFax(thisCsCentre.fax);
    setCurrentContact(thisCsCentre.contact);
    setCurrentContactEmail(thisCsCentre.contactEmail);
    setCurrentContactPhone(thisCsCentre.contactPhone);
    setCurrentFullAddress(thisCsCentre.fullAddress);
    setCurrentPostCode(thisCsCentre.postCode);
    setCurrentLongitude(thisCsCentre.longitude);
    setCurrentLatitude(thisCsCentre.latitude);
    setCurrentWebsite(thisCsCentre.website);
    setCurrentPracticeType(thisCsCentre.practiceType);
    setCurrentmmmCode(thisCsCentre.mmmCode);
    setCurrentEligibility1(thisCsCentre.eligibility1);
    setCurrentEligibility2(thisCsCentre.eligibility2);
    setCurrentEligibility3(thisCsCentre.eligibility3);
    setCurrentEligibilitySpecial(thisCsCentre.eligibilitySpecial);
    setCurrentDocumentLink(thisCsCentre.documentLink);
    setCurrentDefaultReminderEmail(thisCsCentre.defaultReminderEmail);
    setCurrentNewPathwaysDocument(null);
    setCurrentRHCContact(thisCsCentre.rhcContactUserID);
    setCurrentOpenHours(thisCsCentre.openHours);
    setCurrentRating(thisCsCentre.rating ? thisCsCentre.rating : 1);
    setCurrentEngagementStrategy(thisCsCentre.engagementStrategy);
    setCurrentNotes(thisCsCentre.generalNotes);
    setShow(true);
  };

  const createNewCsCentre = () => {
    setCurrentID(0);
    setCurrentCenterName();
    setCurrentEmail();
    setCurrentPhone();
    setCurrentFax();
    setCurrentContact();
    setCurrentContactEmail();
    setCurrentContactPhone();
    setCurrentFullAddress();
    setCurrentPostCode();
    setCurrentLongitude();
    setCurrentLatitude();
    setCurrentWebsite();
    setCurrentPracticeType();
    setCurrentmmmCode();
    setCurrentEligibility1("No");
    setCurrentEligibility2("No");
    setCurrentEligibility3("No");
    setCurrentEligibilitySpecial("No");
    setCurrentDefaultReminderEmail("");
    setCurrentNewPathwaysDocument(null);
    setCurrentRHCContact(0);
    setCurrentOpenHours("");
    setCurrentRating(1);
    setCurrentEngagementStrategy("");
    setCurrentNotes("");
    setShow(true);
  };

  function putCsCentre() {
    // Move from useState to FormData
    const formData = new FormData();
    //
    // Add fields
    formData.append("id", currentID);
    formData.append("centerName", currentCenterName);
    formData.append("email", currentEmail);
    formData.append("phone", currentPhone);
    formData.append("fax", currentFax);
    formData.append("contact", currentContact);
    formData.append("contactEmail", currentContactEmail);
    formData.append("contactPhone", currentContactPhone);
    formData.append("fullAddress", currentFullAddress);
    formData.append("postCode", currentPostCode);
    formData.append("longitude", currentLongitude);
    formData.append("latitude", currentLatitude);
    formData.append("website", currentWebsite);
    formData.append("practiceType", currentPracticeType);
    formData.append("mmmCode", currentmmmCode);
    formData.append("eligibility1", currentEligibility1);
    formData.append("eligibility2", currentEligibility2);
    formData.append("eligibility3", currentEligibility3);
    formData.append("eligibilitySpecial", currentEligibilitySpecial);
    formData.append("newPathwaysDocument", currentNewPathwaysDocument);
    formData.append("defaultReminderEmail", currentDefaultReminderEmail);
    formData.append("rhcContactUserID", currentRHCContact);
    formData.append("openHours", currentOpenHours);
    formData.append("rating", currentRating);
    formData.append("engagementStrategy", currentEngagementStrategy);
    formData.append("generalNotes", currentNotes);
    process.env.REACT_APP_DEBUG && console.log(...formData);
    process.env.REACT_APP_DEBUG && console.log("Saving data");
    // Save update
    dispatch(Admin.actions.putCsCentre({ formData }));
    setShow(false);
  }

  function PathwaysDownload(props) {
    // Check to see if link is populated
    if (!props.documentLink) {
      return null;
    }
    //
    return (
      <Button variant="info" size="sm" href={props.documentLink}>
        <DescriptionIcon fontSize="small" style={{ marginRight: 6, marginTop: -1 }} /> Download
      </Button>
    );
  }

  function handleFileFieldChangeNewPathwaysDocument(propertyName, event) {
    setCurrentNewPathwaysDocument(event.currentTarget.files[0]);
  }

  function setFlag(event, id, flag) {
    // console.log("Setting centre flag", { id, flag, newFlag: event.target.value });
    if (event.target.value !== flag) {
      dispatch(Admin.actions.putCSCentreFlag({ id: id, flag: event.target.value }));
    }
  }

  function setAgentFlag(event, id, flag, csCentreID) {
    // console.log("Setting agent flag", { id, flag, newFlag: event.target.value, csCentreID });
    if (event.target.value !== flag) {
      dispatch(Admin.actions.putCSAgentFlag({ id: id, flag: event.target.value, csCentreID: csCentreID }));
    }
  }

  const rowsWithExpansion = React.useMemo(() => {
    const newRows = [];

    filteredCsCentres.forEach((centre) => {
      newRows.push(centre); // push main centre row

      // if this centre is expanded, inject agent rows
      if (expandedRowId === centre.id) {
        const centreAgents = csAgents.filter((agent) => String(agent.csCentreID) === String(centre.id));

        centreAgents.forEach((agent) => {
          newRows.push({
            ...agent,
            isAgentRow: true,
            parentCentreId: centre.id,
          });
        });
      }
    });

    return newRows;
  }, [filteredCsCentres, expandedRowId, csAgents]);

  const columns = [
    {
      field: "expand",
      headerName: " ",
      width: 60,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        if (params.row.isAgentRow) return null; // agent rows have no arrow

        const isExpanded = expandedRowId === params.row.id;

        return (
          <IconButton
            size="small"
            onClick={() => {
              setExpandedRowId(isExpanded ? null : params.row.id);
              if (!isExpanded) {
                dispatch(Admin.actions.fetchCsAgents({ csCentreID: params.row.id }));
                setCurrentCentreID(params.row.id);
              }
            }}
          >
            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        );
      },
    },
    { field: "id", headerName: "ID", width: 100, hide: true },
    {
      field: "centerName",
      headerName: "Center Name",
      width: 240,
      renderCell: (params) => {
        if (params.row.isAgentRow) return params.row.fullname; // show agent name

        return (
          <strong>
            <div
              onClick={() => loadCsCentreDetail(csCentres.find((c) => c.id === params.row.id))}
              className="cell-Link"
              style={{
                color: params.row.rating === 3 ? "red" : params.row.rating === 2 ? "orange" : "green",
              }}
            >
              {params.value}
            </div>
          </strong>
        );
      },
    },
    {
      field: "email",
      headerName: "Email",
      width: 220,
      renderCell: (params) => (params.row.isAgentRow ? params.row.email : params.value || ""),
    },
    {
      field: "contact",
      headerName: "Mobile Phone",
      width: 150,
      renderCell: (params) => (params.row.isAgentRow ? params.row.mobilephone : params.value || ""),
    },
    {
      field: "status",
      headerName: "Status",
      width: 120,
      renderCell: (params) => (params.row.isAgentRow ? params.row.status : params.value || ""),
    },
    { field: "contact", headerName: "Contact", width: 200 },
    {
      field: "rhcContactUserID",
      headerName: "RHC Contact",
      width: 150,
      valueGetter: (params) => {
        const user = actualUsers.find((user) => String(user.id) === String(params.value));
        return user ? `${user.firstname}` : "";
      },
    },
    {
      field: "totalPsychologistBookings",
      headerName: "PS",
      width: 120,
      description: "Total Psychologist Bookings (All Time)",
    },
    {
      field: "totalPsychologistBookings30",
      headerName: "PS30",
      width: 120,
      description: "Psychologist Bookings (Last 30 Days)",
    },
    {
      field: "totalPsychiatristBookings",
      headerName: "PT",
      width: 120,
      description: "Total Psychiatrist Bookings (All Time)",
    },
    {
      field: "totalPsychiatristBookings30",
      headerName: "PT30",
      width: 120,
      description: "Psychiatrist Bookings (Last 30 Days)",
    },
    {
      field: "flag",
      headerName: "Notes",
      width: 250,
      cellClassName: (params) => (params.row && params.row.flag && params.row.flag.length > 0 ? "flag-full-cell" : "flag-empty-cell"),
      renderCell: (params) => (
        <>
          <TextField
            variant="outlined"
            name={`flag`}
            defaultValue={params.row.flag}
            onBlur={(event) =>
              params.row.isAgentRow ? setAgentFlag(event, params.row.id, params.row.flag, currentCentreID) : setFlag(event, params.row.id, params.row.flag)
            }
            InputProps={{
              classes: {
                notchedOutline: classes.noBorder,
                input: params.row && params.row.flag && params.row.flag.length > 0 ? "flag-full" : "flag-empty",
              },
            }}
            multiline
            maxRows={4}
            style={{ width: "100%" }}
            onFocus={(event) => {
              event.target.select();
            }}
          ></TextField>
        </>
      ),
    },
  ];

  function handleClose() {
    setShow(false);
  }

  const handleSearch = (event) => {
    const searchTerm = event.target.value;
    setSearchTerm(searchTerm);
  };

  return (
    <>
      <Grid container direction="row" justifyContent="space-between">
        <Grid item>
          <h4 style={{ marginBottom: 12 }}>Centralised Service Centre Maintenance</h4>
        </Grid>
      </Grid>

      <Paper>
        <Grid container justifyContent="space-between" style={{ padding: 10 }}>
          <Grid item xs={6} md={4} style={{ marginTop: 2, marginLeft: 10 }}>
            <InputGroup size="sm">
              <InputGroup.Prepend>
                <InputGroup.Text>
                  <SearchIcon fontSize="small" style={{ marginLeft: -4 }} />
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control
                type="text"
                placeholder="Search Centre Information and Staff"
                value={searchTerm}
                onChange={(event) => handleSearch(event)}
                autoComplete="OFF"
              />
            </InputGroup>
          </Grid>
          <Grid item sx={{ ml: "auto", display: "flex" }}>
            <Button
              variant="outline-primary"
              className="mr-2"
              style={{ minWidth: 190 }}
              size="sm"
              disabled={contactDownloadStatus === "Fetching"}
              onClick={() => startDownload("CentreContact", "All_Centre_Contacts")}
            >
              {activeDownloadType === "CentreContact" && contactDownloadStatus === "Fetching" ? (
                <>
                  <Spinner animation="border" size="sm" variant="primary" className="mr-1" />
                  Downloading...
                </>
              ) : (
                "Download Centre Contacts"
              )}
            </Button>
            <Button
              variant="outline-primary"
              className="mr-2"
              style={{ minWidth: 190 }}
              size="sm"
              disabled={contactDownloadStatus === "Fetching"}
              onClick={() => startDownload("AgentContact", "Staff_Information")}
            >
              {activeDownloadType === "AgentContact" && contactDownloadStatus === "Fetching" ? (
                <>
                  <Spinner animation="border" size="sm" variant="primary" className="mr-1" />
                  Downloading...
                </>
              ) : (
                "Download Staff Info"
              )}
            </Button>
            <Button variant="primary" size="sm" disabled={contactDownloadStatus === "Fetching"} onClick={() => createNewCsCentre()}>
              Create Centre
            </Button>
          </Grid>
        </Grid>
      </Paper>

      <Paper style={{ height: 700 }}>
        <DataGridPro
          rows={rowsWithExpansion}
          columns={columns}
          rowHeight={40}
          getRowId={(row) => (row.isAgentRow ? `agent-${row.id}` : row.id)}
          checkboxSelection={false}
          density="compact"
        />
      </Paper>

      <Modal show={show} onHide={handleClose} dialogClassName="contracts-modal">
        <Modal.Header closeButton className="contracts-modal">
          <Modal.Title>Centre Maintenance </Modal.Title>
        </Modal.Header>
        <Modal.Body className="contracts-modal">
          <Paper style={{ backgroundColor: "rgb(245,245,245)", padding: 20 }}>
            <Tabs id="EditModal" activeKey={key} onSelect={(k) => setKey(k)} mountOnEnter={true}>
              <Tab
                eventKey="centreDetails"
                title={currentID && currentID === 0 ? "Add New Centre" : "Update Existing Centre"}
                style={{ backgroundColor: "rgb(245, 245, 245)", padding: 6 }}
              >
                <Row>
                  <Col md="6">
                    <Form.Group>
                      <Form.Label>Centre Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="CenterName"
                        defaultValue={currentCenterName}
                        onBlur={(event) => setCurrentCenterName(event.target.value)}
                        autoComplete="new-password"
                      />
                    </Form.Group>
                  </Col>
                  <Col md="3">
                    <Form.Group>
                      <Form.Label>Rating</Form.Label>
                      <Form.Control as="select" name="Rating" defaultValue={currentRating} onChange={(event) => setCurrentRating(event.target.value)}>
                        <option value={1}>Green</option>
                        <option value={2}>Amber</option>
                        <option value={3}>Red</option>
                      </Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md="8">
                    <Form.Group style={{ width: "100%" }}>
                      <Form.Label>Centre Address</Form.Label>
                      <PlacesAutoComplete
                        currentID={currentID}
                        currentfulladdress={currentFullAddress}
                        setcurrentfulladdress={setCurrentFullAddress}
                        setcurrentLatitude={setCurrentLatitude}
                        setcurrentLongitude={setCurrentLongitude}
                        setcurrentPostCode={setCurrentPostCode}
                      />
                    </Form.Group>
                  </Col>
                  <Col md="4">
                    <Form.Group>
                      <Form.Label>Reporting Postcode</Form.Label>
                      <Form.Control
                        type="text"
                        name="Postcode"
                        defaultValue={currentPostCode}
                        onBlur={(event) => setCurrentPostCode(event.target.value)}
                        autoComplete="new-password"
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md="6">
                    <Form.Group>
                      <Form.Label>Centre Admin Email</Form.Label>
                      <Form.Control
                        type="text"
                        name="Email"
                        defaultValue={currentEmail}
                        onBlur={(event) => setCurrentEmail(event.target.value)}
                        autoComplete="new-password"
                      />
                    </Form.Group>
                  </Col>
                  <Col md="3">
                    <Form.Group>
                      <Form.Label>Phone</Form.Label>
                      <Form.Control
                        type="text"
                        name="Phone"
                        defaultValue={currentPhone}
                        onBlur={(event) => setCurrentPhone(event.target.value)}
                        autoComplete="new-password"
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md="6">
                    <Form.Group>
                      <Form.Label>Open Hours</Form.Label>
                      <Form.Control
                        type="text"
                        name="OpenHours"
                        defaultValue={currentOpenHours}
                        onBlur={(event) => setCurrentOpenHours(event.target.value)}
                        autoComplete="new-password"
                        multiline
                        rows={3}
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col md="6">
                    <Form.Group style={{ width: "100%" }}>
                      <Form.Label>RHC Contact for Centre</Form.Label>
                      <Autocomplete
                        id="rhccontactowner"
                        variant="outlined"
                        options={actualUsers}
                        getOptionLabel={(option) => option.firstname + " " + option.surname}
                        value={actualUsers.find((v) => String(v.id) === String(currentRHCContact)) || null}
                        onChange={(e, value) => {
                          setCurrentRHCContact(value.id);
                        }}
                        style={{
                          fullWidth: true,
                          display: "flex",
                          wrap: "nowrap",
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            type="text"
                            variant="outlined"
                            margin="dense"
                            name="rhccontactowner"
                            style={{
                              backgroundColor: "white",
                              margin: 0,
                              padding: 0,
                            }}
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: "new-password",
                            }}
                          />
                        )}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md="6">
                    <Form.Group className="mb-0" style={{ width: "100%" }}>
                      <Form.Label>Default Email for Centre Reminders</Form.Label>
                      <Form.Control
                        type="text"
                        name="DefaultReminderEmail"
                        defaultValue={currentDefaultReminderEmail}
                        onBlur={(event) => setCurrentDefaultReminderEmail(event.target.value)}
                        autoComplete="new-password"
                      />
                    </Form.Group>
                  </Col>
                  {/* <Col md="6">
                    <Form.Group className="mb-0" style={{ width: "100%", marginTop: "25px" }}>
                      <Form.Label style={{ fontStyle: "italic", color: "blue" }}>
                        If default is entered, all centre related booking remidners will be sent to this address rather than the Client Centre Contact.
                      </Form.Label>
                    </Form.Group>
                  </Col> */}
                </Row>
                <Row>
                  <Form.Label style={{ marginLeft: 10, fontWeight: "bold" }}>Centre Manager Contact Information</Form.Label>
                </Row>
                <Row>
                  <Col md="5">
                    <Form.Group>
                      <Form.Label>Name</Form.Label>
                      <Form.Control
                        type="text"
                        name="Contact"
                        defaultValue={currentContact}
                        onBlur={(event) => setCurrentContact(event.target.value)}
                        autoComplete="new-password"
                      />
                    </Form.Group>
                  </Col>
                  <Col md="4">
                    <Form.Group>
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        type="text"
                        name="ContactEmail"
                        defaultValue={currentContactEmail}
                        onBlur={(event) => setCurrentContactEmail(event.target.value)}
                        autoComplete="new-password"
                      />
                    </Form.Group>
                  </Col>
                  <Col md="3">
                    <Form.Group>
                      <Form.Label>Phone</Form.Label>
                      <Form.Control
                        type="text"
                        name="ContactPhone"
                        defaultValue={currentContactPhone}
                        onBlur={(event) => setCurrentContactPhone(event.target.value)}
                        autoComplete="new-password"
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <hr />
                <Row>
                  <Col md="6">
                    <Form.Group>
                      <Form.Label>Centres Emergency Pathways Document:</Form.Label>
                      <div style={{ width: "100%" }}>
                        <PathwaysDownload documentLink={currentPathWaysLink} />
                      </div>
                    </Form.Group>
                  </Col>
                  <Col md="6">
                    <Form.Group>
                      <Form.Label>Upload New:</Form.Label>
                      <Form.Control
                        type="file"
                        name="NewPathwaysDocument"
                        onChange={(event) => handleFileFieldChangeNewPathwaysDocument("newPathwaysDocument", event)}
                        className="form-control"
                        style={{ paddingTop: 6, paddingLeft: 6 }}
                      />
                      -
                    </Form.Group>
                  </Col>
                </Row>
              </Tab>
              <Tab eventKey="engagementStrategy" title="Engagement Strategy" style={{ backgroundColor: "rgb(245, 245, 245)", padding: 6 }}>
                <Row>
                  <Col md="12">
                    <Form.Group>
                      <Form.Label>Engagement Strategy</Form.Label>
                      <Form.Control
                        as="textarea"
                        name="EngagementStrategy"
                        defaultValue={currentEngagementStrategy}
                        onBlur={(event) => setCurrentEngagementStrategy(event.target.value)}
                        autoComplete="new-password"
                        rows={15}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Tab>
              <Tab eventKey="notes" title="Notes" style={{ backgroundColor: "rgb(245, 245, 245)", padding: 6 }}>
                <Row>
                  <Col md="12">
                    <Form.Group>
                      <Form.Label>Notes (Team/Size etc)</Form.Label>
                      <Form.Control
                        as="textarea"
                        name="Notes"
                        defaultValue={currentNotes}
                        onBlur={(event) => setCurrentNotes(event.target.value)}
                        autoComplete="new-password"
                        rows={15}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </Tab>
              <Tab eventKey="staff" title="Staff" style={{ backgroundColor: "rgb(245, 245, 245)", padding: 6 }}>
                {currentID && currentID === 0 ? (
                  <div>Please save centre details before adding staff.</div>
                ) : (
                  <>
                    <Paper>
                      <Grid container justifyContent="flex-end" style={{ padding: 10 }}>
                        <Grid item style={{ marginLeft: 20, marginRight: 10 }}>
                          <Button variant="primary" size="sm" onClick={() => loadNewCsAgent()} style={{ marginRight: 20 }}>
                            Add Staff
                          </Button>
                        </Grid>
                      </Grid>
                    </Paper>
                    <Paper style={{ height: 700 }}>
                      <DataGridPro
                        rows={csAgents}
                        columns={agentColumns}
                        pageSize={10}
                        rowsPerPageOptions={[10]}
                        checkboxSelection={false}
                        sortModel={[{ field: "fullname", sort: "desc" }]}
                      />
                    </Paper>
                  </>
                )}
              </Tab>
              <Tab eventKey="eligibility" title="Eligibility" style={{ backgroundColor: "rgb(245, 245, 245)", padding: 6 }}>
                {currentID && currentID === 0 ? (
                  <div>Please save centre details before adding Eligibility information.</div>
                ) : (
                  <>
                    <Row>
                      <Col md="8">
                        <Form.Group>
                          <Form.Label> MMM Code *</Form.Label>
                          <Form.Control
                            as="select"
                            defaultValue={currentmmmCode}
                            onBlur={(event) => setCurrentmmmCode(event.target.value)}
                            disabled={role !== "Admin"}
                          >
                            <option value="MMM1 (Metropolitan)">MMM1 (Metropolitan)</option>
                            <option value="MMM2 (Regional centre)">MMM2 (Regional centre)</option>
                            <option value="MMM3 (Large rural town)">MMM3 (Large rural town)</option>
                            <option value="MMM4 (Medium rural town)">MMM4 (Medium rural town)</option>
                            <option value="MMM5 (Small rural town)">MMM5 (Small rural town)</option>
                            <option value="MMM6 (Remote communities)">MMM6 (Remote communities)</option>
                            <option value="MMM7 (Very remote communities)">MMM7 (Very remote communities)</option>
                          </Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="8">
                        <Form.Group>
                          <Form.Label> Priority 1: Centre operating for less than 12 months? *</Form.Label>
                          <Form.Control
                            as="select"
                            defaultValue={currentEligibility1}
                            onBlur={(event) => setCurrentEligibility1(event.target.value)}
                            disabled={role !== "Admin"}
                          >
                            <option value="No">No</option>
                            <option value="Yes">Yes</option>
                          </Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="8">
                        <Form.Group>
                          <Form.Label> Priority 2: MMM Code 3-7 *</Form.Label>
                          <Form.Control
                            as="select"
                            defaultValue={currentEligibility2}
                            onBlur={(event) => setCurrentEligibility2(event.target.value)}
                            disabled={role !== "Admin"}
                          >
                            <option value="No">No</option>
                            <option value="Yes">Yes</option>
                          </Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="8">
                        <Form.Group>
                          <Form.Label> Priority 3: Satellite Centre *</Form.Label>
                          <Form.Control
                            as="select"
                            defaultValue={currentEligibility3}
                            onBlur={(event) => setCurrentEligibility3(event.target.value)}
                            disabled={role !== "Admin"}
                          >
                            <option value="No">No</option>
                            <option value="Yes">Yes</option>
                          </Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="8">
                        <Form.Group>
                          <Form.Label> Special exemption granted *</Form.Label>
                          <Form.Control
                            as="select"
                            defaultValue={currentEligibilitySpecial}
                            onBlur={(event) => setCurrentEligibilitySpecial(event.target.value)}
                            disabled={role !== "Admin"}
                          >
                            <option value="No">No</option>
                            <option value="Yes">Yes</option>
                          </Form.Control>
                        </Form.Group>
                      </Col>
                    </Row>
                  </>
                )}
              </Tab>
            </Tabs>
          </Paper>
        </Modal.Body>
        <Modal.Footer className="contracts-modal">
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={putCsCentre}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showCsAgent} onHide={handleCsAgentClose} dialogClassName="invite-modal">
        <Modal.Header closeButton className="invite-modal">
          <Modal.Title>{currentAgentModalHeader}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="invite-modal">
          {csAgentError !== "" ? (
            <Alert severity="error" style={{ marginBottom: 14 }}>
              {csAgentError}
            </Alert>
          ) : null}
          <h4>Personal Details</h4>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>First Name*</Form.Label>
                <Form.Control
                  type="text"
                  name="profileFirstName"
                  defaultValue={currentAgentFirstName}
                  onBlur={(event) => setcurrentAgentFirstName(event.target.value)}
                  autoComplete="new-password"
                />
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Label>Surname*</Form.Label>
                <Form.Control
                  type="text"
                  name="profileSurname"
                  defaultValue={currentAgentSurname}
                  onBlur={(event) => setcurrentAgentSurname(event.target.value)}
                  autoComplete="new-password"
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Email*</Form.Label>
                <Form.Control
                  type="text"
                  name="profileEmail"
                  defaultValue={currentAgentEmail}
                  onBlur={(event) => setcurrentAgentEmail(event.target.value)}
                  autoComplete="new-password"
                />
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Label>Mobile Phone Number*</Form.Label>
                <Form.Control
                  type="text"
                  name="profileMobile"
                  defaultValue={currentAgentMobile}
                  onBlur={(event) => setcurrentAgentMobile(event.target.value)}
                  autoComplete="new-password"
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <Form.Group style={{ width: "100%" }}>
                <Form.Label>TimeZone</Form.Label>
                <Autocomplete
                  id="profileTimeZone"
                  variant="outlined"
                  options={timeZone}
                  getOptionLabel={(option) => option.name}
                  value={timeZone.find((v) => v.systemName === currentAgentTimeZone) || ""}
                  onChange={(event, newValue) => handleTimeZoneAutocompleteChange("profileTimeZone", event, newValue)}
                  style={{ fullWidth: true, display: "flex", wrap: "nowrap" }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      type="text"
                      variant="outlined"
                      margin="dense"
                      name="TimeZoneSelector"
                      style={{
                        backgroundColor: "white",
                        margin: 0,
                        padding: 0,
                      }}
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: "new-password",
                      }}
                    />
                  )}
                />
              </Form.Group>
            </Col>
          </Row>
          {role === "Admin" ? (
            <Row>
              <Col md="4">
                <Form.Group>
                  <Form.Label>Admin Access for this Centre</Form.Label>
                  <Form.Control as="select" defaultValue={currentAgentAdmin} onBlur={(event) => setcurrentAgentAdmin(event.target.value)}>
                    <option value="Yes">Yes</option>
                    <option value="No">No</option>
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
          ) : null}
          <h4>Multi Factor Authentication</h4>
          <hr></hr>
          <Row>
            <Col md="3">
              <Form.Group>
                <Form.Label> Status</Form.Label>
                <Form.Control
                  type="text"
                  name="MFAConfigured"
                  value={
                    currentAgentMFAStatus === "Configured"
                      ? "Authenticator MFA Configured"
                      : currentAgentMFAStatus === "EmailMFA"
                        ? "Email MFA Configured"
                        : "Not Configured"
                  }
                  readOnly
                />
              </Form.Group>
            </Col>
            {currentAgentMFAStatus !== "Configured" && currentAgentMFAStatus != "EmailMFA" ? (
              <Col md="3" style={{ paddingTop: 29 }}>
                <Button variant="primary" size="sm" style={{ marginLeft: 5 }} disabled>
                  Enable via Profile Page
                </Button>
              </Col>
            ) : (
              <Col md="3" style={{ paddingTop: 29 }}>
                <Button variant="danger" size="sm" style={{ marginLeft: 5 }} onClick={() => DeactivateMFA(currentAgentID)} disabled={userAdmin !== "Yes"}>
                  Disable
                </Button>
              </Col>
            )}
          </Row>

          <h4>{currentAgentPasswordHeader}</h4>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>New Password</Form.Label>
                <Form.Control
                  type="password"
                  name="newpassword"
                  defaultValue={currentAgentNewPassword}
                  onBlur={(event) => setcurrentAgentNewPassword(event.target.value)}
                  autoComplete="new-password"
                />
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Label>New Confirm Password</Form.Label>
                <Form.Control
                  type="password"
                  name="newpasswordconfirmation"
                  defaultValue={currentAgentNewPasswordConfirmation}
                  onBlur={(event) => setcurrentAgentNewPasswordConfirmation(event.target.value)}
                  autoComplete="new-password"
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Status</Form.Label>
                <Form.Control as="select" defaultValue={currentAgentStatus} onBlur={(event) => setcurrentAgentStatus(event.target.value)}>
                  <option value="Active">Active</option>
                  <option value="Archived">Inactive</option>
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="invite-modal">
          <Button variant="secondary" onClick={handleCsAgentClose}>
            Close
          </Button>
          <Button variant="primary" onClick={postCsAgent}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer
        position="bottom-right"
        transition={Flip}
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}
